/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Tag_TitleInputs */

const en_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Tag`)
};

const fr_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le tag`)
};

const de_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag entfernen`)
};

const it_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi tag`)
};

const ru_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить тег`)
};

const es_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar etiqueta`)
};

const zh_cn2_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除标签`)
};

const ja_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグを削除`)
};

const hi_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग हटाएं`)
};

const pt_pt2_tags_manager_remove_tag_title = /** @type {(inputs: Tags_Manager_Remove_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover etiqueta`)
};

/**
* | output |
* | --- |
* | "Remove Tag" |
*
* @param {Tags_Manager_Remove_Tag_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_tag_title = /** @type {((inputs?: Tags_Manager_Remove_Tag_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Tag_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_remove_tag_title(inputs)
	if (locale === "de") return de_tags_manager_remove_tag_title(inputs)
	if (locale === "it") return it_tags_manager_remove_tag_title(inputs)
	if (locale === "ru") return ru_tags_manager_remove_tag_title(inputs)
	if (locale === "es") return es_tags_manager_remove_tag_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_remove_tag_title(inputs)
	if (locale === "ja") return ja_tags_manager_remove_tag_title(inputs)
	if (locale === "hi") return hi_tags_manager_remove_tag_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_remove_tag_title(inputs)
	return en_tags_manager_remove_tag_title(inputs)
});